import {Component, OnInit, Input} from '@angular/core';
import {PropertyService} from '../services/property.service';
import {Property} from '../../../../types/admin-data.types';
import {ApiClientService} from '../../../../services/api-client.service';
import {ICondoManagerBuildingFolder} from '../../../../types/api-response/condomanager/building-folder';

declare const swal;

@Component({
    selector: 'item-view',
    templateUrl: './item-view.component.html',
    styleUrls: ['./item-view.component.scss']
})
export class ItemViewComponent implements OnInit {
    @Input() itemData: Property;
    @Input() close;

    constructor(
        public propertyService: PropertyService,
        public api: ApiClientService
    ) {}

    ngOnInit() {
        this.itemData = JSON.parse(JSON.stringify(this.itemData));
    }

    updateServices(serviceData) {
        if (serviceData.type === 'edit') {
            this.propertyService.updateCurrentServices(serviceData.data).subscribe(
                () => this.propertyService.currentServices.serviceIdentifier = JSON.parse(JSON.stringify(serviceData.data.serviceIdentifier))
            );
        } else {
            serviceData.data.buildingId = this.itemData.id;
            this.propertyService.createCurrentServices(serviceData.data).subscribe(
                () => this.propertyService.getCurrentServices(this.itemData.id)
            );
        }

    }

    update(data) {
        this.propertyService.update(this.itemData.id, data).subscribe(() => this.propertyService.get());
    }

    get buildingFolder(): ICondoManagerBuildingFolder | null {
        return this.propertyService.buildingFolders.find(el => +el.bdId === +this.itemData.id) || null;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/item-view.component.ts